/**
 * Restricts common Inspect Element / Developer Tools entry points.
 * Controlled by theme setting: settings.enable_devtools_restriction
 * Note: This is a deterrent only; it cannot fully prevent DevTools access.
 */
(function () {
  'use strict';

  if (window.__keltecDevtoolsRestrictionActive) return;
  window.__keltecDevtoolsRestrictionActive = true;

  const isMac = /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);

  function isDevToolsShortcut(event) {
    const key = event.key || '';
    const code = event.code || '';
    const keyLower = key.toLowerCase();

    // F12
    if (key === 'F12' || code === 'F12') return true;

    // Ctrl+Shift+I / J / C / K (Windows/Linux)
    if (event.ctrlKey && event.shiftKey) {
      if (['i', 'j', 'c', 'k'].includes(keyLower)) return true;
      if (['KeyI', 'KeyJ', 'KeyC', 'KeyK'].includes(code)) return true;
    }

    // Cmd+Option+I / J / C (macOS)
    if (isMac && event.metaKey && event.altKey) {
      if (['i', 'j', 'c'].includes(keyLower)) return true;
      if (['KeyI', 'KeyJ', 'KeyC'].includes(code)) return true;
    }

    // Ctrl+U / Cmd+U (view source)
    if ((event.ctrlKey || event.metaKey) && (keyLower === 'u' || code === 'KeyU')) {
      return true;
    }

    // Ctrl+Shift+U (some browsers)
    if (event.ctrlKey && event.shiftKey && (keyLower === 'u' || code === 'KeyU')) {
      return true;
    }

    return false;
  }

  document.addEventListener(
    'contextmenu',
    function (event) {
      event.preventDefault();
    },
    { capture: true }
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (isDevToolsShortcut(event)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
    { capture: true }
  );

  document.addEventListener(
    'keyup',
    function (event) {
      if (isDevToolsShortcut(event)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
    { capture: true }
  );

  // Block drag-select of images as a light content-protection aid
  document.addEventListener(
    'dragstart',
    function (event) {
      if (event.target && event.target.tagName === 'IMG') {
        event.preventDefault();
      }
    },
    { capture: true }
  );
})();
